export const framesConstants = {
    GET_ALL_FRAMES_REQUEST: 'GET_ALL_FRAMES_REQUEST',
    GET_ALL_FRAMES_SUCCESS: 'GET_ALL_FRAMES_SUCCESS',
    GET_ALL_FRAMES_FAILURE: 'GET_ALL_FRAMES_FAILURE',

    UPLOAD_FRAME_REQUEST: 'UPLOAD_FRAME_REQUEST',
    UPLOAD_FRAME_SUCCESS: 'UPLOAD_FRAME_SUCCESS',
    UPLOAD_FRAME_FAILURE: 'UPLOAD_FRAME_FAILURE',

    UPDATE_FRAME_REQUEST: 'UPDATE_FRAME_REQUEST',
    UPDATE_FRAME_SUCCESS: 'UPDATE_FRAME_SUCCESS',
    UPDATE_FRAME_FAILURE: 'UPDATE_FRAME_FAILURE',

    DELETE_FRAME_REQUEST: 'DELETE_FRAME_REQUEST',
    DELETE_FRAME_SUCCESS: 'DELETE_FRAME_SUCCESS',
    DELETE_FRAME_FAILURE: 'DELETE_FRAME_FAILURE'
}


// WEBPACK FOOTER //
// ./src/constants/frames.js